import { appInfo } from '@/mocks/homeData';

export default function AppModule() {
  return (
    <section id="app" className="w-full py-14 md:py-20 bg-background-100/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 bg-background-50 rounded-2xl border border-background-200/70 p-8 md:p-12">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              {appInfo.title}
            </h2>
            <p className="text-sm md:text-base text-foreground-500 font-body mb-6">
              {appInfo.subtitle}
            </p>
            <ul className="flex flex-col gap-3 mb-6">
              {appInfo.features.map((feat, i) => (
                <li key={i} className="flex items-center gap-2.5 text-sm text-foreground-600 font-body">
                  <div className="w-5 h-5 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 shrink-0">
                    <i className="ri-check-line text-xs"></i>
                  </div>
                  {feat}
                </li>
              ))}
            </ul>
            <div className="flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
              <button className="inline-flex items-center gap-2 px-6 py-3 bg-foreground-900 text-background-50 font-semibold text-sm rounded-lg hover:bg-foreground-800 transition-colors duration-200 whitespace-nowrap cursor-pointer">
                <i className="ri-smartphone-line"></i>
                手机浏览器打开
              </button>
              <button className="inline-flex items-center gap-2 px-6 py-3 bg-background-100 border border-secondary-300 text-foreground-700 font-medium text-sm rounded-lg hover:bg-secondary-50 transition-colors duration-200 whitespace-nowrap cursor-pointer">
                <i className="ri-qr-code-line"></i>
                扫码访问
              </button>
            </div>
          </div>
          <div className="lg:shrink-0">
            <div className="relative w-48 h-64 md:w-56 md:h-72 rounded-2xl overflow-hidden border-4 border-foreground-900">
              <div className="w-full h-full bg-gradient-to-b from-primary-500 to-accent-500 flex flex-col items-center justify-center gap-3 p-4">
                <div className="w-12 h-12 rounded-xl bg-background-50/20 flex items-center justify-center">
                  <i className="ri-fire-line text-2xl text-background-50"></i>
                </div>
                <span className="text-background-50 font-heading text-lg font-bold">网红黑料</span>
                <span className="text-background-50/70 text-xs font-label">移动吃瓜版</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}